module.exports = __webpack_public_path__ + "04_mid_black.b5364757.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/04_mid_black.png
// module id = x05l
// module chunks = 0